module.exports = __webpack_public_path__ + "media/images/novem_logo-d8c17813f1d3396c8a45632ac13917e5.png";